import ArrowLeft from "@svg/new-design/arrow-left";
import { toFarsiNumber } from "@utils/digits";
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_VARIANT,
} from "@shared/components/button/types";
import { FC } from "react";
import { Button } from "@shared/components/button";

interface Props {
  watchPercent: number;
  boughtLabel: string;
  hasCertificate?: boolean;
}
const BoughtFooterCard: FC<Props> = ({
  watchPercent,
  boughtLabel,
  hasCertificate = false,
}) => {
  return (
    <>
      <div className="w-full shrink-0 bg-fds-secondary rounded-2 h-1 mt-1.5 md:mt-2.5">
        <div
          className="bg-fds-brand h-1 rounded-full"
          style={{ width: `${watchPercent}%` }}
        />
      </div>
      <div className="flex flex-col w-full justify-center h-fds-34 sm:h-9   mt-1.5 ">
        <div className="flex justify-between items-center h-6  w-full">
          <p className="body-xxsm sm:body-xsm text-fds-tertiary">
            {watchPercent !== 0 && `${toFarsiNumber(watchPercent)}% تکمیل شده`}
          </p>
          {(watchPercent !== 100 || hasCertificate) && (
            <Button
              variant={BUTTON_VARIANT.TEXT_ACTION}
              color={BUTTON_COLOR.PRIMARY}
              endIcon={
                watchPercent === 100 && !hasCertificate ? null : (
                  <ArrowLeft className="sm:h-5 sm:w-5 h-4 w-4 " />
                )
              }
              size={BUTTON_SIZE.SMALL}
            >
              {boughtLabel}
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default BoughtFooterCard;
